import { useState } from 'react'
import { PageHero, ProjectGrid, CtaSection, Pagination } from '../../components'
import { useProjects } from '../../features/projects/hooks/useProjects'
import useDocumentTitle from '../../hooks/useDocumentTitle'
import './NoiThat.css'

const BREADCRUMBS = [
  { label: 'Trang chủ', path: '/' },
  { label: 'Thiết kế nội thất' },
]

const NoiThatPage = () => {
  useDocumentTitle('Thiết Kế Nội Thất - MAXCONST')

  useState(() => {
    try {
      sessionStorage.setItem('lastVisitedList', '/noi-that')
      sessionStorage.setItem('lastVisitedListName', 'Thiết kế nội thất')
    } catch (e) {
      // ignore
    }
  })

  const {
    currentProjects,
    loading,
    error,
    currentPage,
    totalPages,
    totalCount,
    startIndex,
    endIndex,
    setCurrentPage,
    goToNextPage,
    goToPrevPage,
    getPageNumbers,
  } = useProjects({
    category: 'noi-that',
    pages: 10,
  })

  return (
    <div className="noi-that-page">
      {/* Hero */}
      <PageHero
        tag="Thiết Kế Nội Thất"
        title="Thiết Kế Nội Thất Cao Cấp MAXCONST"
        titleHighlight="Thiết Kế Nội Thất"
        description="Khám phá hàng trăm mẫu thiết kế nội thất chung cư, nhà phố, biệt thự sang trọng và hiện đại"
        breadcrumbs={BREADCRUMBS}
        stats={
          totalCount > 0
            ? [
                { number: `${totalCount}+`, label: 'Mẫu thiết kế' },
                { number: '10+', label: 'Năm kinh nghiệm' },
                { number: '100%', label: 'Thợ tay nghề cao' },
              ]
            : undefined
        }
      />

      {/* Content */}
      <div className="container section">
        {/* Projects Grid */}
        <ProjectGrid
          projects={currentProjects}
          loading={loading}
          error={error}
        />

        {/* Pagination */}
        {!loading && !error && totalPages > 1 && (
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            totalCount={totalCount}
            startIndex={startIndex}
            endIndex={endIndex}
            getPageNumbers={getPageNumbers}
            onPageChange={setCurrentPage}
            onPrev={goToPrevPage}
            onNext={goToNextPage}
          />
        )}

        {/* CTA */}
        <CtaSection
          title="Bạn Đang Tìm Phương Án Nội Thất Cho Nhà Mình?"
          titleHighlight="Phương Án Nội Thất"
          description="Liên hệ ngay để nhận phương án bố trí mặt bằng công năng 2D và phối cảnh 3D nội thất tối ưu từ kiến trúc sư"
        />
      </div>
    </div>
  )
}

export default NoiThatPage
